const getSubdomain = (domainSubfolder, networkDomain) => {
    try {
        if (domainSubfolder) {
            const url = new URL(`https://${domainSubfolder}`);
            return {
                subfolder: (url === null || url === void 0 ? void 0 : url.pathname) === '/' ? '' : url === null || url === void 0 ? void 0 : url.pathname,
                domain: (url === null || url === void 0 ? void 0 : url.host) || networkDomain,
            };
        }
    }
    catch (err) {
        console.error('Cannot parse maskDomain and subfolder from domainSubfolder');
    }
    return { subfolder: '', subfolderDomain: null, domain: networkDomain };
};
export const getDomainInfo = (network) => {
    const domainSubfolder = (network === null || network === void 0 ? void 0 : network.domainSubfolder) || (network === null || network === void 0 ? void 0 : network.domain);
    const { subfolder, domain } = getSubdomain(domainSubfolder, network === null || network === void 0 ? void 0 : network.domain);
    return {
        domain,
        subfolder,
    };
};
export const getOriginURLs = (networkDomain, hostDomain, subfolder) => {
    if (!subfolder) {
        return [`${networkDomain}`];
    }
    if (networkDomain === hostDomain) {
        return [`${networkDomain}${subfolder}`];
    }
    if (subfolder) {
        return [`${networkDomain}${subfolder}`, `${hostDomain}${subfolder}`];
    }
};
//# sourceMappingURL=domain.js.map